export const STATUS_FIELD_FETCH_TRANSITIONS_KEY = 'issue-field.status.fetch-transitions';
export const STATUS_FIELD_POST_TRANSITION_KEY = 'issue-field.status.post-transition';
export const STATUS_FIELD_FETCH_VIEW_WORKFLOW = 'issue-field.status.fetch-view-workflow';

export const PERMISSION_VIEW_READONLY_WORKFLOW = 'VIEW_READONLY_WORKFLOW';
export const PERMISSION_ADMINISTER = 'ADMINISTER';
